/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts" />

declare var irep: IREP.IREP;

namespace IREP {

    export class IRegistrationVerifyOptions {
        id: string;
    }

    export class RegistrationVerify extends Component {
        private finishProfile: JQuery;
        private doItLater: JQuery;

        constructor(options: IRegistrationVerifyOptions) {
            super(options.id);

            this.finishProfile = this.$component.find(".finishButton"); //The registration submit button
            this.doItLater = this.$component.find(".skipLink"); //The registration submit button

            this.bindEvents();
            this.configurePage();
        }

        private configurePage() {
            if (window.location.search.indexOf('mobile') > -1) {
                $("#registrationBar").show();
                $("#register6_header").hide();
                $(".createAccountBanner").css('margin-top', '40px');
            } else {
                $("#registrationBar").hide();
$("#register6_header").hide();
            }
        }

        private bindEvents() {
            this.unbindEvents();

            this.finishProfile.on("click", (e) => this.goToFinish(e));
            this.doItLater.on("click", (e) => this.goToLogin(e));
        }

        private unbindEvents() {
            this.finishProfile.unbind('click');
            this.doItLater.unbind('click');
        }

        private goToFinish(e: JQueryEventObject) {
            var qq = this;
            e.preventDefault();

            $.ajax({
                type: "get",
                dataType: "html",
                url: irep.options.appUrl + "FinishProfile",
                data: $("#formVerify").serialize()
            }).done(function (data) {
                //Move on to the next step. 
                $("#RegistrationContainer").html(data);
            })
        }

        private goToLogin(e: JQueryEventObject) {
            e.preventDefault();
            if (window.location.search.indexOf('mobile') > -1) {
                window.history.go(-(window.history.length - 1)); return false; 
            }
            else {
                window.location.href = "/";
            }
        }
    }
}